import Layout from '@/components/layout/index.vue'

export default {
  path: 'relation',
  name: 'Relation',
  meta: { title: '关系管理' },
  component: Layout,
  redirect: { name: 'Relation.Setting' },
  children: [{
    path: 'supplier',
    name: 'Relation.Supplier',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "relation" */ '@/views/purchaser/relation/supplier/index.ts')
  },
  {
    path: 'company',
    name: 'Relation.Company',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "relation" */ '@/views/purchaser/relation/company/index.ts')
  },
  {
    path: 'setting',
    name: 'Relation.Setting',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "relation" */ '@/views/purchaser/relation/setting/index.ts')
  },
  {
    path: 'setting/modify',
    name: 'Relation.Setting.Modify',
    meta: { title: 'common.modify', dep: 'Relation.Setting' },
    component: () =>
                import(/* webpackChunkName: "relation" */ '@/views/purchaser/relation/setting/modify.ts')
  },
  {
    path: 'purchaser',
    name: 'Relation.Purchaser',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "relation" */ '@/views/purchaser/relation/purchaser/index.ts')
  }
  ]
}
